import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i2 from '@simpl/element-ng/translate';
import { SiTranslateModule } from '@simpl/element-ng/translate';

class SiIconComponent {
    /** Icon token, see {@link https://simpl.code.siemens.io/simpl/icons/element} */
    icon;
    /** Color class, see {@link https://simpl.code.siemens.io/simpl-element/fundamentals/typography/#color-variants-classes} */
    color;
    /** Icon token, see {@link https://simpl.code.siemens.io/simpl-element/fundamentals/icons/} */
    stackedIcon;
    /** Color class, see {@link https://simpl.code.siemens.io/simpl-element/fundamentals/icons/} */
    stackedColor;
    /** Alternative name or translation key for icon. Used for A11y. */
    alt;
    /** Text-size class for icon size, see {@link https://simpl.code.siemens.io/simpl-element/fundamentals/typography/#type-styles-classes} */
    size = 'icon';
    altText = '';
    ngOnChanges(changes) {
        if (changes.icon || changes.alt) {
            this.altText = this.alt ?? this.icon?.replace('element-', '').split('-').join(' ') ?? '';
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiIconComponent, selector: "si-icon", inputs: { icon: "icon", color: "color", stackedIcon: "stackedIcon", stackedColor: "stackedColor", alt: "alt", size: "size" }, usesOnChanges: true, ngImport: i0, template: "<span\n  class=\"d-inline-block position-relative\"\n  [attr.aria-label]=\"altText ? (altText | translate) : null\"\n  [attr.role]=\"altText ? 'img' : 'presentation'\"\n  [ngClass]=\"[icon ?? '', color ?? '', size]\"\n>\n  <i\n    *ngIf=\"stackedIcon\"\n    class=\"position-absolute start-0\"\n    aria-hidden=\"true\"\n    [ngClass]=\"[stackedIcon, stackedColor ?? '']\"\n  ></i>\n</span>\n", styles: [":host,span{line-height:1}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i2.SiTranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiIconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-icon', changeDetection: ChangeDetectionStrategy.OnPush, template: "<span\n  class=\"d-inline-block position-relative\"\n  [attr.aria-label]=\"altText ? (altText | translate) : null\"\n  [attr.role]=\"altText ? 'img' : 'presentation'\"\n  [ngClass]=\"[icon ?? '', color ?? '', size]\"\n>\n  <i\n    *ngIf=\"stackedIcon\"\n    class=\"position-absolute start-0\"\n    aria-hidden=\"true\"\n    [ngClass]=\"[stackedIcon, stackedColor ?? '']\"\n  ></i>\n</span>\n", styles: [":host,span{line-height:1}\n"] }]
        }], propDecorators: { icon: [{
                type: Input
            }], color: [{
                type: Input
            }], stackedIcon: [{
                type: Input
            }], stackedColor: [{
                type: Input
            }], alt: [{
                type: Input
            }], size: [{
                type: Input
            }] } });

class SiIconModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiIconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiIconModule, declarations: [SiIconComponent], imports: [CommonModule, SiTranslateModule], exports: [SiIconComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiIconModule, imports: [CommonModule, SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiIconModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, SiTranslateModule],
                    declarations: [SiIconComponent],
                    exports: [SiIconComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SiIconComponent, SiIconModule };
